export default {
  module: {
    name: 'Source name',
    type: 'Module type',
    version: 'Version',
    latest_version: 'Latest version',
    description: 'Description',
    upgrade: 'Upgrade'
  },
  user: {
    title: 'User',
    management: 'User management',
    maintenance: 'Maintenance',
    licensing: 'Licensing',
    modules: 'Modules',
    misc: 'Misc',
    login: 'Login',
    password: 'Password',
    name: 'Name',
    role: 'Role',
    select_role: 'Select Role',
    login_table: 'User login',
    add_new: 'Add new user',
    update: 'Update user',
    wrongCredentials: 'Incorrect login or password'
  },
  current_user: {
    title: 'Current user'
  },
  users: {
    title: 'All users'
  },
  alarms: {
    title: 'Alarms',
    servers_status: 'Servers status',
    pipelines_status: 'Pipelines status',
    db_status: 'DB status',
    user_notifications: 'User notifications',
    events: 'Events'
  },
  db: {
    title: 'System Database'
  },
  license: {
    title: 'License'
  },
  backup: {
    title: 'All configurations'
  },
  logs: {
    title: 'Logs'
  },
  change: {
    name: 'Change name',
    password: 'Change password'
  }
}
